import { render, staticRenderFns } from "./sendChat.vue?vue&type=template&id=17874547&scoped=true&"
import script from "./sendChat.vue?vue&type=script&lang=js&"
export * from "./sendChat.vue?vue&type=script&lang=js&"
import style0 from "./sendChat.vue?vue&type=style&index=0&id=17874547&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17874547",
  null
  
)

export default component.exports